import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { ModalCadastroComponent } from '../../../shared/modal-cadastro/modal-cadastro.component';

@Component({
  selector: 'app-impressao-tabelas-preco',
  templateUrl: './impressao-tabelas-preco.component.html',
  styleUrls: ['./impressao-tabelas-preco.component.css']
})
export class ImpressaoTabelasPrecoComponent extends ModalCadastroComponent implements OnInit {
  @ViewChild('modalRelatorio', { static: true }) modalRelatorio;
  form: FormGroup;

  constructor() {
    super();
  }

  ngOnInit() {
    this.form = new FormGroup({
      agruparLinhaProdutos: new FormControl(false),
      isPdf: new FormControl(true),
    });
  }

  show(): void {
    this.modalRelatorio.show();
  }

  close(): void {
    this.closed.emit(null);
  }

  imprimir(): void {
    this.closed.emit(this.form.value);
  }
}
